'use client';

import { apiSwagger } from '@/shared/api';
import etaLoader from '@/sharedTypes/EtaLoader';
import { Author, Category } from '@/sharedTypes/Api';
import { action, makeObservable, observable } from 'mobx';

export enum SAMPLES_MODE {
  EDIT,
  UPLOAD,
  SELECT,
}

export const popupCoords = {
  bottom: '50%',
  left: '50%',
  top: undefined,
  right: undefined,
};
// export const popupCoords = {
//   bottom: "50%",
//   left: "50%",
//   top: undefined,
//   right: undefined,
// }

class SamplesModel {
  sampleInfo: {
    author: Author;
    category: Category;
    title: { en: string; ru: string };
  } = {
    author: { _id: '', en: '', ru: '' },
    category: { _id: '', en: '', ru: '' },
    title: { en: '', ru: '' },
  };

  // Keep a backup copy to restore from if needed
  public _sampleInfoBackup: {
    author: Author;
    title: { en: string; ru: string };
    category: Category;
  } | null = null;

  currentMode = SAMPLES_MODE.SELECT;
  samplesHidden = true;
  ref: React.Ref<HTMLDivElement> | null = null;
  public samplesModelBtn: React.Ref<HTMLDivElement> | null = null;

  async setSampleInfo(sampleInfo: any) {
    // Guard against setting incomplete sampleInfo
    if (!sampleInfo || !sampleInfo.title || !sampleInfo.author) {
      return;
    }
  // Fetch full author by ID
  let author: Author = { _id: '', en: '', ru: '' };
  if (sampleInfo.author) {
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('preparingMusicEngine', 0.6);
    }
    const authorRes = await apiSwagger.authors.authorsList();
    const authorData = await authorRes.json();
    author = authorData.data.find((a: Author) => a._id === sampleInfo.author) || author;
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('preparingMusicEngine', 0.8);
    }
  }

  // Fetch full category by ID
  let category: Category = { _id: '', en: '', ru: '' };
  if (sampleInfo.category) {
    const categoryRes = await apiSwagger.categories.categoriesList();
    const categoryData = await categoryRes.json();
    category = categoryData.data.find((c: Category) => c._id === sampleInfo.category) || category;
  }
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('preparingMusicEngine', 1);
    }
  // Set sampleInfo with fetched objects
  this.sampleInfo = {
    title: { ...sampleInfo.title },
    author: { ...author },
    category: { ...category },
  };


    // Also save a backup copy
    this._sampleInfoBackup = {
      title: { ...sampleInfo.title },
      author: { ...author },
      category: { ...category },
    };
  }

  restoreFromBackup() {
    if (
      this._sampleInfoBackup &&
      this._sampleInfoBackup.title.en &&
      this._sampleInfoBackup.author.en
    ) {
      this.sampleInfo = {
        title: { ...this._sampleInfoBackup.title },
        author: { ...this._sampleInfoBackup.author },
        category: { ...this._sampleInfoBackup.category },
      };
    }
  }

  constructor() {
    makeObservable(this, {
      samplesModelBtn: observable,
      sampleInfo: observable,
      currentMode: observable,
      samplesHidden: observable,
      setSampleInfo: action,
      restoreFromBackup: action,
    });

    // Initialize global instance only in browser environment
    if (typeof window !== 'undefined') {
      (window as any).samplesModel = this;
    }
  }
}

const samplesModel = new SamplesModel();
export default samplesModel;
